(() => {
  const normalizeTitle = title => String(title || '').normalize('NFKC').replace(/\s+/g, ' ').trim();
  const storageKey = 'mebore-review-product-cache-v4';
  const inFlight = new Map();
  let storedProducts = {};

  try {
    storedProducts = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
  } catch (_) {}

  const remember = (title, product) => {
    if (!product?.url) return product;
    storedProducts[title] = product;
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(storedProducts));
    } catch (_) {}
    return product;
  };

  const cleanProductUrl = product => {
    if (!product?.url) return product;
    try {
      const url = new URL(product.url, window.location.origin);
      return { ...product, url: url.pathname };
    } catch (_) {
      return product;
    }
  };

  const fetchProduct = async normalizedTitle => {
    try {
      const searchUrl = new URL('/search', window.location.origin);
      searchUrl.searchParams.set('q', normalizedTitle);
      searchUrl.searchParams.set('type', 'product');
      searchUrl.searchParams.set('section_id', 'review-product-resolver');
      const response = await fetch(searchUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) return null;
      const documentFromSearch = new DOMParser().parseFromString(await response.text(), 'text/html');
      const payload = documentFromSearch.querySelector('[data-review-product-results]')?.textContent;
      const products = payload ? JSON.parse(payload) : [];
      const exact = products.find(product => normalizeTitle(product.title) === normalizedTitle);
      return remember(normalizedTitle, cleanProductUrl(exact || products[0] || null));
    } catch (_) {
      return null;
    }
  };

  window.MeboreReviewProductResolver = {
    resolve(title) {
      const normalizedTitle = normalizeTitle(title);
      if (!normalizedTitle) return Promise.resolve(null);
      if (storedProducts[normalizedTitle]?.url) return Promise.resolve(storedProducts[normalizedTitle]);
      if (!inFlight.has(normalizedTitle)) {
        inFlight.set(normalizedTitle, fetchProduct(normalizedTitle).finally(() => inFlight.delete(normalizedTitle)));
      }
      return inFlight.get(normalizedTitle);
    }
  };
})();
